import { Box } from "@mui/material"
import Typography from "@mui/material/Typography"
import styled from "@emotion/styled"
import { useEffect, useState } from "react"
import { useLogger } from "@sb1finans/components/dist/SB1Logger"
import Alert from "@mui/material/Alert"
import { messagesApi } from "../api"

const MessageList = styled.ul`
    padding: 0;
    margin: 0;
`

const ListItem = styled.li`
    background: #fff;
    box-shadow: 0 1px 4px 0 rgb(38 38 38 / 30%);
    padding: 24px 12px;
    border-radius: 4px;
    margin: 8px 0px;

    &:hover {
      border: 2px solid #002776;
      border-radius: 4px;
    }

    &:last-child {
      margin-bottom: 64px;
    }
`

export const MessagePage = () => {
    const logger = useLogger()
    const [messages, setMessages] = useState<any[]>([])
    const [error, setError] = useState<Error | undefined>()

    const fetchMessages = async () => {
      console.info(`Start fetching messages.`)
      try {
        const response = await messagesApi.listMessages()
        console.info(`Got list of ${response.data.length} from MessagesApi.`)
        setMessages(response.data)
      } catch (e) {
        console.error(`Failed to fetch messages`, e)
        setError(Error("Kunne ikke hente dine meldinger. Prøv på nytt senere."))
      }
    }

    useEffect(() => {
      logger.pageView("MessagePage", window.location.origin)
      fetchMessages()
    }, [])

    const onSelectItem = (message: any) => async () => {
      try {
        const response = await messagesApi.getMessageFile(message.id, {responseType: "blob"})
        
        const href = URL.createObjectURL(response.data as any)

        const link = document.createElement("a")
        link.href = href
        link.setAttribute("download", `${message.title}.pdf`)
        document.body.appendChild(link)
        link.click()

        document.body.removeChild(link)
        URL.revokeObjectURL(href)
        
        console.debug(response)
      } catch (e) {
        setError(Error("Kunne ikke laste ned meldingen. Prøv på nytt senere."))
      }
    }

    return (
        <div>
            <Typography variant="h4" color={"#002776"}>Meldinger</Typography>
                      <Box sx={{height: 8}} />
            <Typography variant="body1" color="#333">
              Her kan du lese personlige meldinger og rentebrev fra finansforetaket.
            </Typography>
            { error && <Alert severity="error">{error.message}</Alert> }
            <MessageList>
              {
                messages && messages.sort((a: any, b: any) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()).map((message) => (
                  <ListItem onClick={onSelectItem(message)} key={message.id}>
                      <Typography variant="h5" color={"#002776"}>{message.title}</Typography>
                      <Box sx={{height: 8}} />
                      <Typography variant="body1"  color={"#cecece"}>{new Date(message.createdAt).toLocaleString("no-NO", { weekday: "long", year: "numeric", month: "long", day: "numeric"})}</Typography>
                  </ListItem>
                ))
              }
            </MessageList>
        </div>
    )
}